(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atr-campaign-pair"] && !Shopify.designMode) return;
  try {
    
(() => {
 const measure = () => {
  const header = document.querySelector('header.site');
  const announcement = document.querySelector('.atr-service-bar');
  const height = (header?.getBoundingClientRect().height || 70) + (announcement?.getBoundingClientRect().height || 0);
  document.documentElement.style.setProperty('--atr-opening-header', height + 'px');
 };
 const init = () => {measure(); const observer=new ResizeObserver(measure); document.querySelectorAll('header.site,.atr-service-bar').forEach(e=>observer.observe(e));};
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atr-cart"]) return;
  try {
    
(() => {
  function setup(form) {
    if (form.dataset.atrCartInit) return;
    form.dataset.atrCartInit = 'true';

    let timer;
    const queueUpdate = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'update';
        hidden.value = '';
        form.appendChild(hidden);
        form.submit();
      }, 700);
    };

    form.querySelectorAll('[data-atr-qty]').forEach(input => {
      input.addEventListener('change', () => {
        const n = parseInt(input.value, 10);
        if (isNaN(n) || n < 0) input.value = 0;
        else if (n > 99) input.value = 99;
        queueUpdate();
      });
    });

    form.addEventListener('submit', () => {
      clearTimeout(timer);
      window.requestAnimationFrame(() => {
        form.querySelectorAll('button[type="submit"]').forEach(b => { b.disabled = true; });
      });
    });
  }

  async function reconcilePreorders() {
    const stockData = document.querySelector('[data-atr-cart-stock]');
    if (!stockData || !stockData.textContent.trim()) return;
    const root = window.Shopify?.routes?.root || '/';
    let changed = false;
    try {
      const stocks = JSON.parse(stockData.textContent);
      let response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      let current = await response.json();
      const totals = {};
      current.items.forEach(item => totals[item.variant_id] = (totals[item.variant_id] || 0) + item.quantity);
      const candidates = current.items.filter(item => item.properties?.Preorder && Object.hasOwn(stocks, String(item.variant_id)) && (stocks[item.variant_id] === null || stocks[item.variant_id] >= totals[item.variant_id]));
      for (const candidate of candidates) {
        const item = current.items.find(line => line.key === candidate.key);
        if (!item) continue;
        response = await fetch(root + 'cart/change.js', {
          method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:item.key,quantity:item.quantity,properties:{...item.properties,Preorder:''}})
        });
        if (!response.ok) break;
        current = await response.json();
        changed = true;
      }
    } catch {}
    if (changed) location.reload();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcilePreorders); else reconcilePreorders();

  const init = () => document.querySelectorAll('[data-atr-cart-form]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atr-collection"]) return;
  try {
    
document.querySelectorAll('[data-ar-filters]').forEach(root=>{
 const section=root.closest('section'),grid=section.querySelector('.ar-product-grid'),cards=[...section.querySelectorAll('[data-atr-card]')],inputs=[...root.querySelectorAll('[data-filter]')];
 const update=()=>{let count=0;const chosen=inputs.filter(i=>i.checked&&i.value);cards.forEach(card=>{const tags=JSON.parse(card.dataset.filterTags||'[]').map(t=>t.toLowerCase()),sizes=JSON.parse(card.dataset.filterSizes||'[]').map(t=>t.toLowerCase());const color=tags.includes('tee')?'white':tags.includes('dubai')?'brown':tags.includes('porto-cervo')?'burgundy':'navy';const match=chosen.every(i=>i.dataset.filter==='size'?sizes.includes(i.value.toLowerCase()):i.dataset.filter==='color'?color===i.value:tags.includes(i.value));card.hidden=!match;if(match)count++;});root.querySelector('[data-filter-count]').textContent=count+' products';section.querySelector('[data-filter-empty]').hidden=count!==0;};
 inputs.forEach(i=>i.addEventListener('change',update));root.querySelector('[data-filter-reset]').addEventListener('click',()=>{inputs.forEach(i=>i.checked=!i.value);update();});root.querySelector('[data-filter-done]').addEventListener('click',()=>root.querySelector('details').open=false);
 root.querySelector('[data-ar-sort]').addEventListener('change',e=>{const mode=e.target.value,sorted=[...cards];if(mode==='name')sorted.sort((a,b)=>a.dataset.filterTitle.localeCompare(b.dataset.filterTitle));else if(mode.startsWith('price'))sorted.sort((a,b)=>(Number(a.dataset.filterPrice)-Number(b.dataset.filterPrice))*(mode==='price-up'?1:-1));sorted.forEach(c=>grid.append(c));});update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atr-editorial-home"] && !Shopify.designMode) return;
  try {
    
(() => {
const init=()=>{document.querySelectorAll('.atr-fit-section').forEach(section=>{if(section.dataset.heightReady)return;const place=section.parentElement.querySelector('.atrd-places .ar-place');if(!place)return;section.dataset.heightReady='true';const measure=()=>{const height=window.matchMedia('(max-width:749px)').matches?(place.parentElement.getBoundingClientRect().width-8)*0.625:place.getBoundingClientRect().height;if(height>0)section.style.setProperty('--atr-place-height',height+'px');};measure();new ResizeObserver(measure).observe(place);});};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atr-header"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('.atr-search-disclosure').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.addEventListener('toggle', () => { if (root.open) { document.querySelector('#mnav')?.classList.remove('open'); const b=document.querySelector('.menu-btn'); b?.setAttribute('aria-expanded','false'); b?.setAttribute('aria-label','Open menu'); root.querySelector('input[type="search"]')?.focus(); } });
    document.addEventListener('click', e => { if (!root.contains(e.target)) root.open=false; });
    document.addEventListener('keydown', e => { if(e.key==='Escape' && root.open) { root.open=false; root.querySelector('summary').focus(); } });
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atr-join"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.atrJoinInit) return;
    root.dataset.atrJoinInit = 'true';
    const focusTarget = root.querySelector('[data-atr-join-focus]');
    if (focusTarget) focusTarget.focus();
    const copyButton = root.querySelector('[data-atr-join-copy]');
    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const value = copyButton.dataset.atrJoinCopy;
        let ok = false;
        try { await navigator.clipboard.writeText(value); ok = true; } catch {
          try {
            const field = document.createElement('textarea');
            field.value = value; field.setAttribute('readonly',''); field.style.position='fixed'; field.style.opacity='0';
            document.body.appendChild(field); field.select(); ok = document.execCommand('copy'); field.remove();
          } catch {}
        }
        if (ok) {
          const original = copyButton.textContent;
          copyButton.textContent = copyButton.dataset.copied || 'Copied';
          setTimeout(() => { copyButton.textContent = original; }, 2500);
        }
      });
    }
  }
  const init = () => document.querySelectorAll('.atr-join').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atr-newsletter-popup"]) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const panel = root.querySelector('.atr-offer');
    const form = root.querySelector('form');
    const trigger = root.querySelector('[data-atr-offer-open]');
    const preview = root.dataset.preview === 'true';
    const day = 86400000;
    const cooldown = Math.max(1,Number(root.dataset.days)||7)*day;
    const seenKey = 'atr-offer-seen';
    const visitKey = 'atr-offer-visit';
    const subscribedKey = 'atr-welcome-subscribed';
    const read = key => {
      for (const type of ['localStorage','sessionStorage']) {
        try { const value = window[type].getItem(key); if (value !== null) return value; } catch {}
      }
      try { return document.cookie.split('; ').find(item => item.startsWith(key+'='))?.slice(key.length+1)||null; } catch { return null; }
    };
    const save = (key,value,age=cooldown) => {
      for (const type of ['localStorage','sessionStorage']) {
        try { window[type].setItem(key,String(value)); } catch {}
      }
      try { document.cookie = key+'='+value+'; Max-Age='+Math.floor(age/1000)+'; Path=/; SameSite=Lax; Secure'; } catch {}
      return read(key) === String(value);
    };
    const sessionKey='atr-vvp-opening-seen';
    const sessionSeen=()=>{try {if(sessionStorage.getItem(sessionKey)==='1')return true;}catch{}return document.cookie.split('; ').some(c=>c===sessionKey+'=1');};
    const markSession=()=>{try{sessionStorage.setItem(sessionKey,'1');}catch{}document.cookie=sessionKey+'=1; Path=/; SameSite=Lax; Secure';};
    let timer;
    let timeReady = false;
    let done = false;
    const stop = () => {
      done = true;
      clearTimeout(timer);
      window.removeEventListener('scroll',tryAutomatic);
      window.removeEventListener('focus',tryAutomatic);
      document.removeEventListener('visibilitychange',tryAutomatic);
      document.removeEventListener('focusout',tryAutomatic);
    };
    const remember = () => save(seenKey,Date.now());
    const show = (manual=false) => {
      stop();
      remember();
      markSession();
      panel.hidden = false;
      trigger.hidden = true;
      trigger.setAttribute('aria-expanded','true');
      if (manual) (root.querySelector('input[type=email]')||root.querySelector('[data-atr-offer-close]')).focus();
    };
    const close = () => {
      const focusInside = panel.contains(document.activeElement);
      stop();
      remember();
      panel.hidden = true;
      trigger.hidden = false;
      trigger.setAttribute('aria-expanded','false');
      if (focusInside) trigger.focus();
    };
    function tryAutomatic() {
      if (root.dataset.autoOpen !== 'true') return;
      if (done || !timeReady || document.visibilityState !== 'visible') return;
      if (sessionSeen() || read(subscribedKey)) {stop();return;}
      if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
      if ([...document.querySelectorAll('dialog[open],[aria-modal="true"]')].some(el => !el.closest('[hidden]') && el.getClientRects().length > 0)) return;
      show();
    }
    trigger.addEventListener('click',() => show(true));
    document.querySelectorAll('[data-atr-offer-open]').forEach(el => {
      if (el === trigger || el.dataset.atrOfferExternalBound) return;
      el.dataset.atrOfferExternalBound = 'true';
      el.addEventListener('click', event => {
        if (el.hasAttribute('href')) event.preventDefault();
        show(true);
      });
    });
    root.querySelectorAll('[data-atr-offer-close]').forEach(button => button.addEventListener('click',close));
    panel.addEventListener('keydown',event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
    if (preview && form) form.addEventListener('submit',event => {
      event.preventDefault();
      const msg = root.querySelector('[data-atr-preview-success]');
      if (msg) { msg.hidden=false; msg.setAttribute('tabindex','-1'); msg.focus(); }
    });
    const copyButton = root.querySelector('[data-atr-copy]');
    if (copyButton) copyButton.addEventListener('click',async () => {
      const value = copyButton.dataset.atrCopy;
      let ok = false;
      try { await navigator.clipboard.writeText(value); ok = true; } catch {
        try {
          const field = document.createElement('textarea');
          field.value = value; field.setAttribute('readonly',''); field.style.position='fixed'; field.style.opacity='0';
          document.body.appendChild(field); field.select(); ok = document.execCommand('copy'); field.remove();
        } catch {}
      }
      if (ok) {
        const original = copyButton.textContent;
        copyButton.textContent = copyButton.dataset.copied || 'Copied';
        setTimeout(() => { copyButton.textContent = original; },2500);
      } else {
        const node = root.querySelector('[data-atr-code]');
        if (node) { const range = document.createRange(); range.selectNodeContents(node); const sel = getSelection(); sel.removeAllRanges(); sel.addRange(range); }
      }
    });
    function updateTriggerVisibility() {
      if (trigger.hidden) return;
      trigger.style.display = '';
    }
    window.addEventListener('scroll',updateTriggerVisibility,{passive:true});
    window.addEventListener('resize',updateTriggerVisibility);
    updateTriggerVisibility();
    if (root.querySelector('[data-atr-signup-success]')) {
      save(subscribedKey,'1',365*day);
      show();
    } else if (root.querySelector('[data-atr-signup-error]')) {
      show();
    } else if (read(subscribedKey)) {
      root.hidden = true;
      stop();
    } else {
      window.addEventListener('scroll',tryAutomatic,{passive:true});
      window.addEventListener('focus',tryAutomatic);
      document.addEventListener('visibilitychange',tryAutomatic);
      document.addEventListener('focusout',tryAutomatic);
      const scheduleOffer = () => { if (!done) timer = setTimeout(() => { timeReady=true; tryAutomatic(); }, Math.max(8, Number(root.dataset.delay) || 8) * 1000); };
      if (document.readyState === 'complete') scheduleOffer();
      else window.addEventListener('load', scheduleOffer, {once:true});
    }
    window.addEventListener('storage',event => {
      if ([seenKey,'atr-welcome-dismissed-v8',subscribedKey].includes(event.key) && event.newValue) stop();
    });
    window.addEventListener('pagehide',() => { stop(); });
    window.addEventListener('pageshow',event => { if (event.persisted) { panel.hidden=true; trigger.hidden=false; trigger.setAttribute('aria-expanded','false'); stop(); } updateTriggerVisibility(); });
    document.addEventListener('shopify:section:unload',event => { if (event.target.contains(root)) stop(); });
  }
  const init = () => document.querySelectorAll('[data-atr-newsletter]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
